import { styled } from '@mui/material/styles';
import { Box, IconButton, Autocomplete } from '@mui/material';

export const ContainerBox = styled(Box)({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  width: "100%",
  gap: "8px",
  minWidth: 0,
});

export const AutocompleteContainer = styled(Box)({
  flex: 1,
  width: "100%",
  minWidth: 0,
  maxWidth: "100%",
});

export const StyledAutocomplete = styled(Autocomplete)({
  transition: 'none'
});

export const UploadButton = styled(IconButton)({
  border: "1px solid #c2c2c2",
  width: "38px",
  height: "38px",
  flexShrink: 0,
  '& .MuiSvgIcon-root': {
    color: "#000"
  }
}); 